export default __webpack_public_path__ + "media/images/camera-e73873109e82ec9564c6c0415ff41c35.svg";